<template>
    <div class="chat-box available-chat-box">
        <div class="chat-box-header available-header">
            <back-button class="chat-box-header__back" @click.native="back">{{ $t("common.back") }}</back-button>
            <segment-control @select="changeType($event.value)" class="chat-box__segment" :segment-data="segmentData"/>
            <div class="chat-box-header__flex-box-stub"></div>
        </div>
        <div class="chat-box-body">
            <div class="chat-list-empty" v-if="collection.length == 0">
                <div class="chat-list-empty__body">
                    <panel-background-icon :title="emptyMessage">
                        <empty-groups v-if="type === 'publicGroup'"></empty-groups>
                        <empty-channels v-else></empty-channels>
                    </panel-background-icon>
                </div>
            </div>
            <template v-else>
                <chat-item v-for="room in collection"
                    :room="room"
                    :key="room.id"
                    @click.native="select(room)"
                >
                </chat-item>
            </template>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue';
    import ChatItem from "./ChatItem";
    import EmptyList from "./EmptyList";
    import Back from "../svg/Back";
    import ChatTypes from "../../enums/ChatTypes";
    import EmptyChannels from "../svg/EmptyChannels";
    import EmptyGroups from "../svg/EmptyGroups";
    import BackButton from "../../../../service/components/common/back-button/BackButton.vue";
    import PanelBackgroundIcon from "@share/common/PanelBackgroundIcon.vue";

    import SegmentControl from '../../../common/segment/Segment.vue'

    export default Vue.extend({
        name: "Available",
        components: {
            ChatItem, EmptyList, Back, EmptyChannels, EmptyGroups, SegmentControl, BackButton, PanelBackgroundIcon
        },
        data() {
            return {
                type: ChatTypes.publicGroup
            }
        },
        computed: {
            groups() {
                return this.$store.state.chat.groups.groups || [];
            },
            channels() {
                return this.$store.state.chat.groups.channels || [];
            },
            collection() {
                return this.type == ChatTypes.publicGroup ? this.groups : this.channels;
            },
            emptyMessage() {
                return this.type == ChatTypes.publicGroup ? this.$t('common.no groups') : this.$t('common.no channels')
            },
            segmentData() {
                return [{
                    active: this.type === ChatTypes.publicGroup,
                    title: this.$t('common.groups'),
                    value: ChatTypes.publicGroup
                },
                {
                    active: this.type === ChatTypes.channel,
                    title: this.$t('common.channels'),
                    value: ChatTypes.channel
                }];
            }
        },
        methods: {
            back() {
                this.$emit('cancel');
            },
            changeType(type) {
                this.type = type;
            },
            select(room) {
                this.$emit('selectRoom', room);
            }
        }
    });
</script>

<style>

</style>